// Remove copy/paste whitespace without changing prefixes or other punctuation.
export function normalisePatientMobile(value) {
    return value == null ? '' : String(value).replace(/\s/g, '')
}

export function isValidPatientMobile(value) {
    const mobile = normalisePatientMobile(value)
    // Mobile remains optional. Match the existing PhoneUtils input format;
    // country parsing and final validation remain the server's responsibility.
    return mobile === '' || /^\+?\(?[0-9]{3}\)?[-.]?[0-9]{3}[-.]?[0-9]{4,6}$/.test(mobile)
}

export function validatePatientMobile(rule, value, callback) {
    callback(isValidPatientMobile(value) ? undefined : new Error(
        'Enter a valid mobile number, for example 0412 345 678 or +61 412 345 678.'
    ))
}
